<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h3>Business Gaming - CMS</h3>
          <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="home" size="lg" [fixedWidth]="true"></fa-icon>
        </div>
        <div class="card-body">
          <p>Welcome to the Business Gaming Content Management System (CMS)</p>
          <p>For navigation, please use the sidebar.</p>
        </div>
      </div>
    </div>
  </div>
</div>
